import { formatTime, getTime } from '@/utils/date';
import Mock from 'mockjs';

export function makeData(num) {
  return Mock.mock({
    runstate: 1,
    state: 0,
    mods: {
      gm606Mod: {
        humidity: 85,
        temp: 32,
        pumpRunstate: 1,
        pumpInstallState: 1,
        sensors: [
          {
            name: '六氟化硫',
            unit: 'VOL%',
            unitName: 'VOL%',
            'value|0-10': 2,
            installState: 1,
            runstate: 1,
            faultState: 0,
            alarmState: 0
          }
        ]
      }
    },
    beginTime: formatTime(new Date('2024-08-15 14:12:00').getTime() + num * getTime('m'))
  });
}
